import { render, staticRenderFns } from "./SetupStep3.vue?vue&type=template&id=a92b578a&"
import script from "./SetupStep3.vue?vue&type=script&lang=ts&"
export * from "./SetupStep3.vue?vue&type=script&lang=ts&"
import style0 from "./SetupStep3.vue?vue&type=style&index=0&id=a92b578a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports